export { default } from "./VocabToolTipDialog";
